import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '../../../components/layout/PageHeader';
import { EstimateCalculator } from '../../../features/schemes/components/EstimateCalculator';

export const Route = createFileRoute('/_auth/schemes/estimate')({
  component: ChitEstimatePage,
});

function ChitEstimatePage() {
  return (
    <div className="flex flex-col w-full h-full" style={{ viewTransitionName: 'page-body' }}>
      <PageHeader title="Chit Estimate" subtitle="Calculate and preview chit scheme projections." backTo="/schemes" />
      <div className="flex-1 w-full min-h-0">
        <EstimateCalculator />
      </div>
    </div>
  );
}
